const createHistory = require("history").createBrowserHistory;
const History = createHistory();

module.exports = History;



// WEBPACK FOOTER //
// ./src/wiring/history.js